export interface BusinessTripsRouter {
  goToList(query?: string): void;
  goToDetail(id: string): void;
  goToCreate(search: string): void;
  goToCreateBatch(params: {
    companyId: string;
    eventTypeId: string;
    employeeId?: string;
    parentEventId?: string;
  }): void;
  goBack(prevState: { pathname: string; search: string }): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessTripsRouter = Symbol('BusinessTripsRouter');
